import React, { FC } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { ControlledSelect } from 'transfix-form/components'
import { Grid } from 'transfix-ui/core'
import { IShipmentIssueTypeSlaBasedOn } from 'types/graphqlTypes'
import { useIssueTypeFormContext } from '../../hooks/useIssueTypeForm'

export const NUM_SECONDS_IN_HOUR = 60 * 60 // BE takes in SLA duration as the time in seconds

const ONE_TO_24_HOURS = [...Array(24).keys()].map((_, index) => ({
  value: (index + 1) * NUM_SECONDS_IN_HOUR,
  label: `${index + 1} hours`,
}))

const SLA_DURATION_OPTIONS: ISelectOption[] = [
  {
    value: 0,
    label: `0 hours`,
  },
  {
    value: 0.5 * NUM_SECONDS_IN_HOUR,
    label: `30 minutes`,
  },
  ...ONE_TO_24_HOURS,
]

const SLA_BASED_ON_OPTIONS: ISelectOption[] = [
  {
    value: IShipmentIssueTypeSlaBasedOn.issue_creation,
    label: 'Issue Creation',
  },
  {
    value: IShipmentIssueTypeSlaBasedOn.next_appointment_start,
    label: 'Next Appointment Start',
  },
]

const ControlledSlaOptions: FC = () => {
  const { control, errors } = useIssueTypeFormContext()

  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <ControlledSelect
          control={control}
          name='slaDuration'
          SelectProps={{
            options: SLA_DURATION_OPTIONS,
            label: 'SLA Due Within',
            required: true,
            error: !!errors.slaDuration,
            validationMessage: errors.slaDuration?.message,
          }}
        />
      </Grid>
      <Grid item xs={5}>
        <ControlledSelect
          control={control}
          name='slaBasedOn'
          SelectProps={{
            options: SLA_BASED_ON_OPTIONS,
            label: 'Based On',
            required: true,
            error: !!errors.slaBasedOn,
            validationMessage: errors.slaBasedOn?.message,
          }}
        />
      </Grid>
    </Grid>
  )
}

export default ControlledSlaOptions
